export default __webpack_public_path__ + "scripts/resources/assignments/en/autograded/hotcoldpack2025/configuration.json";